<template>
  <v-form v-model="trip.valid">
    <v-container>
      <v-row>
        <v-col
          cols="12"
          md="4"
        >
          <v-text-field
            v-model="trip.name"
            label="Name"
            :rules="[ v => !!v || 'Name is required' ]"
            required
            outlined
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col>
          <v-btn
            color="primary"
            block
            depressed
            :disabled="trip.saving || trip.loading"
            :loading="trip.saving || trip.loading"
            @click="save"
          >
            {{ $route.params.id ? 'Save' : 'Create' }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import { analytics } from '@/plugins/firebase'
import Trip from '@/models/Trip'

export default {
  data () {
    return {
      trip: new Trip()
    }
  },
  watch: {
    '$route' (to, from) {
      this.init()
    }
  },
  mounted () {
    this.init()
  },
  beforeDestroy () {
    this.$store.commit('navigation/setToolbar')
  },
  methods: {
    async init () {
      if (this.$route.params.id) {
        await this.trip.fetch(this.$route.params.id)
      } else {
        this.trip = new Trip()
      }

      this.$store.commit('navigation/setToolbar', {
        title: this.trip.isNew() ? 'Create Trip' : `Edit ${this.trip.name}`
      })
    },
    async save () {
      const isNew = this.trip.isNew()

      if (isNew) {
        this.trip.users[this.$currentUser.id] = 'owner'
      }

      await this.trip.save()

      if (isNew) {
        analytics.logEvent('trip_create')
        this.$router.replace({ name: 'trip', params: { id: this.trip.id } })
      }
    }
  }
}
</script>

<style>

</style>
